import { graphql, useStaticQuery } from 'gatsby'
import { useLangContext } from './lang.context'

function useMenu() {
  const { lang, toggleLang, setLang } = useLangContext()

  const query = useStaticQuery(graphql`
    query {
      blogs: allContentfulBlog(sort: { fields: date, order: DESC }) {
        edges {
          node {
            title
            seo_title
            blog_slug
            lang {
              slug
            }
          }
        }
      }

      industries: allContentfulIndustry(sort: { fields: name }) {
        edges {
          node {
            name
            slug
            lang {
              slug
            }
          }
        }
      }

      services: allContentfulService( sort: {fields: name}) {
        edges {
          node {
            name
            slug
            lang {
              slug
            }
          }
        }
      }

      locations: allContentfulLocation(sort: { fields: name }) {
        edges {
          node {
            name
            slug
            lang {
              slug
            }
          }
        }
      }

      depots: allContentfulDepot(sort: { fields: name }) {
        edges {
          node {
            name
            slug
            lang {
              slug
            }
          }
        }
      }
    }
  `)

  const moreBlogsLinks = {
    pl: '...więcej artykułów',
    en: '...more articles'
  }

  const linksBlogs = query.blogs.edges
  .filter(({ node }) => node.lang.slug === lang)
  .filter(({ node }) => node.title || node.seo_title)
  .filter((_, id) => id < 9)
  .map(({ node: { title, seo_title, blog_slug } }) => {
    const newtitle = title || seo_title
    return {
      name: newtitle.length > 50 ? newtitle?.slice(0, 50) + '...' : newtitle,
      slug: '/blog/' + blog_slug + '/',
    }
  })
  .concat({
    name: moreBlogsLinks[lang],
    slug: '/blog/',
  })

  const linksServices = query.services.edges
    .filter(({ node }) => node.lang.slug === lang)
    .filter(({ node }) => node.name)
    .map(({ node: { name, slug } }) => ({
      name,
      slug: '/' + slug + '/',
    }))

  const linksDepots = query.depots.edges
    .filter(({ node }) => node.lang.slug === lang)
    .filter(({ node }) => node.name)
    .map(({ node: { name, slug } }) => ({
      name,
      slug: '/' + slug + '/',
    }))

  const menu = [
    {
      slug: '/shop/',
      title: {
        pl: 'Sklep',
        en: 'Shop',
        zh: '店铺'
      },
      button: true,
      langs: ['pl', 'en', 'zh']
    },
    {
      slug: '/quote/',
      title: {
        pl: 'Wycena',
        en: 'Quote',
        zh: '报价',
      },
      langs: ['pl', 'en', 'zh']
    },
    {
      slug: '/services/',
      title: {
        pl: 'Usługi',
        en: 'Services',
        zh: '服务',
      },
      links: linksServices,
      langs: ['pl', 'en', 'zh']
    },
    {
      slug: '/depots/',
      title: {
        pl: 'Depoty',
        en: 'Depots',
      },
      links: linksDepots,
      langs: ['pl', 'en']
    },
    {
      slug: '/blog/',
      title: {
        pl: 'Blog',
        en: 'News',
      },
      links: linksBlogs,
      langs: ['pl', 'en']
    },
    {
      slug: '/contact/',
      title: {
        pl: 'Kontakt',
        en: 'Contact',
        zh: '联系方式',
      },
      langs: ['pl', 'en', 'zh']
    },
    {
      title: {
        pl: 'PL',
        en: 'EN',
        zh: '中国人',
      },
      slug: '/',
      links: [
        {
          name: '🇵🇱 Polski',
          slug: 'https://omidatrade.pl',
        },
        {
          name: '🇬🇧 English',
          slug: 'https://omidatrade.com/',
        },
        {
          name: '🇨🇳 中国人',
          slug: 'https://cn.omidatrade.com/',
        },
      ],
      langs: ['pl', 'en', 'zh']
    },
  ].filter(item => item.langs.includes(lang));

  const footer = []

  return { menu, footer }
}

export default useMenu
